const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const coinRateModelGet = ({
    buildingId = '', 
    coinId = '', 
    userId = '',
}) => {
    return {
        buildingId: buildingId,
        coinId: coinId,
        userId: userId,
        created: dateTimeStr,
        date: dateTimeStr,
        rate: decimal,
    }
};